import React from "react";
import NavBar from "../../home/home components/NavBar";
import { Link } from "react-router-dom";
import Footer from "../../home/home components/Footer";
import Floats from "../../home/home components/Floats";
import { Card } from "react-bootstrap";
import "./Results.css";

// ✅ Result Sheet
import ResultSheet from "../../../images/ResultSheet.png";

const Result = () => {

  // ✅ CORRECT WAY (WEBPACK SAFE)
  const importAll = (r) =>
    r.keys()
      .sort((a, b) => a.localeCompare(b)) // ensures order
      .map(r);

  const images = importAll(
    require.context(
      "../../../assets/img/2026/photos",
      false,
      /\.(png|jpe?g|svg)$/
    )
  );

  return (
    <>
      <NavBar />

      {/* Breadcrumb */}
      <section className="breadcrumbs">
        <div className="container">
          <ol>
            <li><Link to="/">Home</Link></li>
            <li>Results</li>
          </ol>
          <h2>Results</h2>
        </div>
      </section>

      {/* Results */}
      <section className="portfolio">
        <div className="container">

          <Card className="text-center shadow-sm">
            <Card.Header>
              <h4>Results</h4>
            </Card.Header>

            {/* I PU */}
            <Card className="m-3 shadow-sm">
              <Card.Body>

                <h4 className="fw-bold mb-4">I PU</h4>

                <h6>PUC Result Analysis</h6>

                {images.map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`result-${i}`}
                    className="img-fluid rounded mb-3"
                  />
                ))}

              </Card.Body>
            </Card>

            {/* Result Sheet */}
            <Card.Body>
              <img
                src={ResultSheet}
                alt="Result"
                className="img-fluid"
                style={{
                  borderRadius: "10px",
                  marginTop: "20px"
                }}
              />
            </Card.Body>

          </Card>

        </div>
      </section>

      <Footer />
      <Floats />
    </>
  );
};

export default Result;